/**
 * i18n initialization — react-i18next + browser language detector.
 *
 * Auto-detects Spanish (`navigator.language` starts with "es") on first visit,
 * persists user choice in localStorage under key ``i18nextLng``, defaults to
 * English otherwise. Missing translation keys silently fall back to the key
 * itself (safer than throwing during progressive rollout).
 */
import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import en from "./locales/en.json";
import es from "./locales/es.json";

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: en },
      es: { translation: es },
    },
    fallbackLng: "en",
    supportedLngs: ["en", "es"],
    interpolation: { escapeValue: false }, // React already escapes
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
      lookupLocalStorage: "i18nextLng",
      // Only match top-level language, so `es-MX`, `es-AR`, `es-ES` all → `es`
      convertDetectedLanguage: (lng) => (lng?.startsWith("es") ? "es" : "en"),
    },
    react: {
      useSuspense: false, // We load synchronously via imports above
    },
  });

export default i18n;
